import React from "react";
import { StoreTeam } from "@coworker/types/lib/storeteam";
import { SwitcherSheet } from "./SwitcherSheet";
import { Store } from "../../../../shared/types/store";
import { StoreEnvironmentSelector } from "./StoreEnvironmentSelector";
import { useTranslation } from "@coworker/locales";

interface SwitchStoreSheetProps {
  stores: Store[] | undefined;
  selectedStore: Store | undefined;
  setSelectedStore: React.Dispatch<React.SetStateAction<Store | undefined>>;
  setSelectedTeam: React.Dispatch<React.SetStateAction<StoreTeam | undefined>>;
  loading: boolean;
}

export const SwitchStoreSheet = (props: SwitchStoreSheetProps) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <>
      <StoreEnvironmentSelector
        id="store"
        value={
          !props.selectedStore?.name
            ? t("chooseAnOptionString")
            : `${props.selectedStore.storeId} - ${props.selectedStore.name}`
        }
        label="adminStoreFilter"
        validationMsg="pleaseSelectAStoreString"
        selectedItem={props.selectedStore}
        loading={props.loading}
        onClick={() => {
          setIsOpen(true);
        }}
      />
      <SwitcherSheet
        titleKey="adminStoreFilter"
        placeholderKey="searchStoreString"
        items={props.stores ?? []}
        selectedItem={props.selectedStore}
        getItemLabel={(store) => `${store?.storeId} - ${store?.name}`}
        getItemKey={(store) => store?.storeId ?? ""}
        onSelect={(store) => {
          props.setSelectedStore(store);
          props.setSelectedTeam({} as StoreTeam);
        }}
        loading={props.loading}
        setIsOpen={setIsOpen}
        isOpen={isOpen}
      />
    </>
  );
};
